const cloneItemIntoPlace = () => {
  const res = resolutionCheck();

  $('.js-clone-item').each(function () {
    let initialPlace = $(this).data('cloneInitial');
    let cloneTargetArray = $(this).data('cloneTarget').split(';');
    cloneTargetArray = cloneTargetArray.map((target) => target.split(':'));

    cloneTargetArray.forEach(([targetRes, target]) => {
      if (res == targetRes) {
        $(this).appendTo('#' + target);
        initialPlace = false;
      }
    });

    if (initialPlace) $(this).appendTo('#' + initialPlace);
  });
};

const cloneInit = () => {
  if ($('.js-clone-item').length) {
    $(function () {
      cloneItemIntoPlace();
    });

    $(window).on('resize orientationchange', function () {
      cloneItemIntoPlace();
    });
  }
};
cloneInit();
